import { apiMain } from './utils';
import { Notificacao } from '../types/Notificacao';

class NotificacaoService {
  private getHeaders() {
    const token = localStorage.getItem('device_token');
    return {
      headers: {
        Authorization: token,
      },
    };
  }

  async buscarNotificacoes(propriedadeId: number): Promise<Notificacao[]> {
    const response = await apiMain.get(`/notificacoes/?propriedade=${propriedadeId}`, this.getHeaders());
    return response.data;
  }

  async marcarComoLida(id: number, propriedadeId: number): Promise<void> {
    await apiMain.patch(`/notificacoes/marcar-como-lido/${id}/?propriedade=${propriedadeId}`, {}, this.getHeaders());
  }

  async marcarTodasComoLidas(propriedadeId: number): Promise<void> {
    await apiMain.patch(`/notificacoes/ler-todas/?propriedade=${propriedadeId}`, {}, this.getHeaders());
  }
}

export default new NotificacaoService(); 